import InputV1 from "_+_Portal/components/Genericos/InputV1/InputV1";
import { BtnEnviar, ContainerAsociarme } from "./localStyle";
import { useContext } from "react";
import { PortalContext } from "_+_Portal/context/Provider";
import { wsGetDniPariente } from "_+_Portal/context/Actions/grupoFamiliar/grupoFamiliar";

const ModalAsociarme = () => {
  const { grupoFamiliarDispatch, grupoFamiliarState } =
    useContext(PortalContext);

  const onChangeInput = (e) => {
    let number = e.target.value;
    // validación de la persona
    if (number.length > 6) {
      wsGetDniPariente(JSON.parse(number))(grupoFamiliarDispatch);
    }
  };

  const onClickDocumento = (e) => {
    let number = e.target.value;
    // validación de la persona
    if (number.length > 6) {
      wsGetDniPariente(JSON.parse(number))(grupoFamiliarDispatch);
    }
  };

  return (
    <ContainerAsociarme>
      <InputV1
        inputType="number"
        errorStr={"El dni es requerido"}
        placeholderText={"12345678"}
        onChange={onChangeInput}
        className={"inputNonScroll customCss"}
        //   checkError={checkError}
        isRequired={true}
        name="dni"
      />
      {Object.keys(grupoFamiliarState.grupoFamiliar.familiar.data).length > 0 &&
        grupoFamiliarState.grupoFamiliar.familiar.data !== 400 && (
          <p>
            Familiar:{" "}
            <span className="rb16b c-latex30">
              {grupoFamiliarState.grupoFamiliar.familiar.data.nombre}
            </span>
          </p>
        )}
      <BtnEnviar
        className={`rb16l ${
          Object.keys(grupoFamiliarState.grupoFamiliar.familiar.data).length >
            0 && grupoFamiliarState.grupoFamiliar.familiar.data !== 400
            ? "bgc-primary"
            : "bgc-grey65"
        } c-white`}
        onClick={
          Object.keys(grupoFamiliarState.grupoFamiliar.familiar.data).length >
            0 && grupoFamiliarState.grupoFamiliar.familiar.data !== 400
            ? onClickDocumento
            : () => {}
        }
      >
        Aceptar
      </BtnEnviar>
    </ContainerAsociarme>
  );
};

export default ModalAsociarme;
